import React from 'react';

import { Alert as AntdAlert } from 'antd';

import { ConditionsReactivateEtatDto } from 'lib_api/lib/api/gen/api';

interface ConditionReactivateEtatProps {
  conditions?: ConditionsReactivateEtatDto;
}

function ConditionReactivateEtat({
  conditions,
}: ConditionReactivateEtatProps): React.ReactElement {
  const isInvalid: boolean =
    (conditions?.etatValid || conditions?.alreadyExist) ?? false;

  return (
    <>
      {isInvalid && (
        <AntdAlert
          type="warning"
          className="alertInvalid"
          message={
            <>
              {conditions?.etatValid && (
                <p className="alertInvalid--txt">
                  L&apos;état est déjà valide.
                </p>
              )}
              {conditions?.alreadyExist && (
                <p className="alertInvalid--txt">L&apos;état existe déjà.</p>
              )}
            </>
          }
        />
      )}
    </>
  );
}

export default ConditionReactivateEtat;
